function waterFlowBanner() {
  function push(data) {
    console.log('push');
    if(typeof data === "function") {
      console.log('calling');
      data();
    } else {
      console.log(data.yandex_stat_id);
      console.log(data.google_adunit_full_path);
      wfBanner(
        data.yandex_stat_id,
        data.yandex_block_id,
        data.node_id,
        data.event_name,
        data.google_adunit_full_path
      );
    }
  }

  function adxBanner(adunitPath, nodeId, actionName = 'banner_direct') {
    console.log('adxbanner', [adunitPath, nodeId, actionName]);

    window.googletag = window.googletag || { cmd: [] };
    googletag.cmd.push(function() {
      var sizes = [[300, 250], [336, 280], 'fluid', [250, 250], [970, 250], [728, 90], [750, 300], [320, 480]].filter(function(size) {
        return !Array.isArray(size) || size[0] <= document.body.clientWidth;
      });

      var slot = googletag.defineSlot(adunitPath, sizes, nodeId).addService(googletag.pubads());

      console.log(sizes);

      if (window.uncart_id && window.uncart_id !== '0.00') {
        slot.setTargeting('floor', floor);
      }

      googletag.pubads().addEventListener('impressionViewable', function(event) {
        if (event.slot !== slot) return; window.api.trackEvent(actionName);
      });

      googletag.pubads().addEventListener("slotResponseReceived", (event) => {
        if (slot === event.slot) {
          console.log("Ad response for slot", slot.getSlotElementId(), "received.");
          console.log(event);
          if(event.isEmpty) {
            console.log('Empty :(') ;
          }
        }
      });

      googletag.pubads().addEventListener("slotRequested", (event) => {
        if (slot === event.slot) {
          console.log("Ad requested for slot", slot.getSlotElementId(), "sent.");
        }
      });
      googletag.pubads().enableSingleRequest();
      googletag.enableServices();
    });

    googletag.cmd.push(function() {
      googletag.display(nodeId);
    });
  }

  function yaBanner(statId, blockId, nodeId, actionName, callOnZero = null) {
    console.log('yabanner');
    window.yaContextCb = window.yaContextCb || [];
    window.yaContextCb.push(() => {
      Ya.Context.AdvManager.render({
        "blockId": blockId,
        "statId": statId,
        "renderTo": nodeId,
        onRender: function(_data) {
          window.api.trackEvent(actionName);
        },
        onError: function(_data) {
          if (callOnZero) {
            callOnZero();
          }
        }
      }, function() {
        if (callOnZero) {
          callOnZero();
        }
      })
    })
  }

  function wfBanner(statId, blockId, nodeId, actionName, adunitPath) {
    yaBanner(statId, blockId, nodeId, actionName, function() {
      adxBanner(adunitPath, nodeId, actionName)
    })
  }

  return {
    push: push,
    wfBanner: wfBanner,
    adxBanner: adxBanner,
    yaBanner: yaBanner
  }
}

// window.wfb = window.wfb || [];
// window.wfb.push({
// yandex_stat_id: id,
// yandex_block_id: 'R-A-...'
// node_id: 'div-1234'
// event_name: 'donwtop_loaded'
// google_adunit_full_path: unit_path
// })


function initWaterFlowBanner() {
  window._wfb = window.wfb;
  window.wfb = waterFlowBanner();

  if (Array.isArray(window._wfb)) {
    window._wfb.forEach((data) => { window.wfb.push(data) });
  }
  return window.wfb;
}

if (document.readyState == 'loading') {
  document.addEventListener("DOMContentLoaded", initWaterFlowBanner);
} else {
  initWaterFlowBanner();
}
